export interface FlatMenuItem {
  label: string;
  link: string;
}

//
// 1. Flatten Menu Tree → Simple List
//
export const flattenMenus = (menuList: any[], arr: FlatMenuItem[] = []) => {
  menuList.forEach((m) => {
    if (m.label && m.link) {
      arr.push({
        label: String(m.label).toLowerCase(),
        link: m.link,
      });
    }

    if (m.submenuItems) {
      flattenMenus(m.submenuItems, arr);
    }
  });

  return arr;
};

//
// 2. Clean Natural Language Query
//
export const normalizeQuery = (query: string) => {
  return query
    .toLowerCase()
    .replace(/open|go to|navigate|show|please|menu|screen|page|take me to/gi, "")
    .trim();
};

//
// 3. Best match logic
//
export const findBestMenuMatch = (
  allMenus: FlatMenuItem[],
  query: string
): FlatMenuItem | null => {
  if (!query) return null;

  const cleaned = normalizeQuery(query);
  const words = cleaned.split(" ").filter(Boolean);

  // 🔥 strong: every word must exist
  let match = allMenus.find((m) =>
    words.every((w) => m.label.includes(w))
  );

  if (!match) {
    // 🔥 medium: startsWith match
    match = allMenus.find((m) =>
      words.some((w) => m.label.startsWith(w))
    );
  }

  if (!match) {
    // 🔥 fuzzy: remove spaces & compare
    const flatQuery = cleaned.replace(/\s+/g, "");
    match = allMenus.find((m) =>
      m.label.replace(/\s+/g, "").includes(flatQuery)
    );
  }

  return match || null;
};

//
// 4. Suggestions List
//
export const generateSuggestions = (
  allMenus: FlatMenuItem[],
  query: string
): FlatMenuItem[] => {
  const cleaned = normalizeQuery(query);

  if (!cleaned) return [];

  const words = cleaned.split(" ").filter(Boolean);

  let matches = allMenus.filter((m) =>
    words.every((w) => m.label.includes(w))
  );

  // expand matches if <3 results
  if (matches.length < 3) {
    const flatQuery = cleaned.replace(/\s+/g, "");

    const fuzzy = allMenus.filter((m) =>
      m.label.replace(/\s+/g, "").includes(flatQuery)
    );

    matches = [...new Set([...matches, ...fuzzy])];
  }

  return matches;
};
